import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin, DateSelector } from '../../../components/molecues';
import { Button, Table, Select, LoadingView } from '../../../../common/components/atoms';

import { COMMENT_STATUS } from '../../../common/constants.js';

class TopTrainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentDate: new Date(),
            searchText: "",
            status: "-1",
            records: [],

            loadedAudio: 0,
            loading: false,
        }
    }

    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: "GetCourseInfo_Saga",
        });
        this.Search();
    }

    onClickUserCtrl = (e) => {
        this.props.history.push('/admin/user');
    }

    onCilckSubjectManage = (e) => {
        this.props.history.push('/admin/trainer/subject');
    }

    onChanageDate = (date) => {
        this.setState({ currentDate: date });
    }

    getDisplayDate() {
        let arr = this.state.currentDate.toString().split(' ');

        return arr[1] + ' ' + arr[3];
    }

    onChangeStatus = (e) => {
        this.setState({ status: e.target.value });
    }

    onChangeSearch = (e) => {
        this.setState({ searchText: e.target.value });
    }

    matchIDorTrainer(id, trainer, search) {
        if (search.match(/^[0-9]+$/)) {
            if (id.indexOf(search) >= 0) {
                return true;
            }
        } else {
            if (trainer.indexOf(search) >= 0) {
                return true;
            }
        }
        return false;
    }

    createRecordData(list) {
        let records = [];
        let sendCount = [];
        let index = 0;
        for (let key in list) {
            if (this.state.status === "-1" || this.state.status === list[key].state.toString()) {
                let i = index;
                let Color = "#888";
                if (list[key].state === 1) {
                    Color = "#FF0000";
                } else if (list[key].state === 2) {
                    Color = "#0077FF";
                } else {
                    Color = "#888";
                }
                let count;
                if (!list[key].cancelFlg) {
                    if (!sendCount[list[key].userID]) {
                        sendCount[list[key].userID] = 1;
                    } else {
                        sendCount[list[key].userID]++;
                    }
                    count = sendCount[list[key].userID];
                } else {
                    count = "-";
                }
                records.push(
                    {
                        id: list[key].id,
                        userID: list[key].userID,
                        submitDate: list[key].sendDatetime ? list[key].sendDatetime : list[key].submitMonth + "-" + list[key].submitDate,
                        sendDatetime: list[key].sendDatetime,
                        sendCount: count,
                        state: list[key].state,
                        stateText: COMMENT_STATUS[list[key].state],
                        charge: list[key].charge,
                        commentDate: list[key].commentDate,
                        feedbackDate: list[key].feedbackDate,
                        title: (
                            <div style={{maxWidth: "200px"}}>
                                <div>
                                    {list[key].subject.title}
                                </div>
                            </div>
                        ),
                        assign: (
                            <TableContrl Color={Color} onClick={e => this.onClickAssign(e, i)}>
                                <i className="fas fa-hand-paper" />
                            </TableContrl>
                        ),
                        audio: list[key].audio,
                        comment: list[key].comment,
                        disable: list[key].cancelFlg,
                        play: 0
                    }
                );
                index++;
            }
        }

        this.setState({
            records: records,
        });
    }

    onClickUpdate = (e) => {
        this.Search();
    }
    onClickSearch = (e) => {
        this.Search();
    }
    Search = () => {
        this.setState({
            loadedAudio: 0,
            loading: false
        })
        let date = this.state.currentDate;
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: "GetRecordList_Saga",
            search: this.state.searchText,
            month: date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2),
            course: -1,
            mode: 1,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        });
    }

    onSuccess = (list) => {
        this.setState({
            records: list,
        })
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.createRecordData(list);
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    
    checkLoadEnded = (loadedAudio) => {
        if(loadedAudio < Object.keys(this.state.records).length) {
            return false;
        }
        return true;
    }

    onClickColumn = (index) => {
    }
    onClickRow = (index) => {
        this.props.dispatch({
            type: "LoadClear"
        });
        this.props.dispatch({
            type: 'RecordEdit',
            record: this.state.records[index],
        });
        this.props.history.push('/admin/trainer/comment-edit');
    }

    onClickAssign(e, index) {
        e.preventDefault();
        e.stopPropagation();
        console.log(index)
    }

    createTableProps() {
        const height = (window.innerHeight - 64 - 20 - 28 - 64) + "px";
        return {
            height: height,
            columns: {
                "ユーザーID": "userID",
                "依頼日時": "submitDate",
                "教材タイトル": "title",
                "依頼回数": "sendCount",
                "対応状況": "stateText",
                "対応トレーナー": "charge",
                "対応開始日": "commentDate",
                "送信完了日時": "feedbackDate",
                "": "assign",
            },
            data: this.state.records,
            onClickColumn: this.onClickColumn,
            onClickRow: this.onClickRow,
        };
    }

    getNotReply() {
        let ret = [];
        for (let key in this.state.records) {
            if (this.state.records[key].state === 0) {
                ret.push(
                    <NotReply key={key}>
                        {this.state.records[key].submitDate + " - ユーザーID : " + this.state.records[key].userID}
                    </NotReply>
                )
            }
        }

        return ret;
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight - 64 - 20) + "px";
        const propsHeader = {
            title: "トレーナーメニュー",
            history: this.props.history,
        }
        const propsTable = this.createTableProps();

        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <Contents Width={width} Height={height}>
                    <Controls>
                        <ControlsChild>
                            <DateSelector onChange={this.onChanageDate}
                                style={{
                                    border: "1px solid #888",
                                    borderRadius: "5px",
                                    width: "150px",
                                    marginLeft: "10px",
                                    padding: "2px 5px",
                                }}
                                Display={true}
                                />
                            <IconOnlyButton Margin={"10px"} onClick={this.onClickUpdate}>
                                <i className="fas fa-undo"></i>
                            </IconOnlyButton>
                            <Select array={COMMENT_STATUS} onChange={this.onChangeStatus} value={this.state.status} />
                            <Input>
                                <input type="text" name="search" value={this.state.searchText} placeholder="ユーザーID または 対応トレーナー"
                                    onChange={this.onChangeSearch}></input>
                            </Input>
                            <IconOnlyButton Margin={"20px"} onClick={this.onClickSearch}>
                                <i className="fas fa-search" />
                            </IconOnlyButton>
                            <div style={{margin: "0 0 0 100px"}}>
                                <Button
                                    Color="#0077FF"
                                    Width="120px"
                                    onClick={this.onClickUserCtrl}
                                    icon={(<i className="fas fa-users" />)}
                                    text="ユーザー管理" />
                            </div>
                        </ControlsChild>
                        <ControlsChild>
                            <Button
                                Color="#0077FF"
                                Width="100px"
                                onClick={this.onCilckSubjectManage}
                                icon={(<i className="fas fa-book" />)}
                                text="教材管理" />
                        </ControlsChild>
                    </Controls>
                    <Results>
                        <Table {...propsTable} />
                        <NoticeWrap>
                            <Notice>
                                {this.getNotReply()}
                            </Notice>
                        </NoticeWrap>
                    </Results>
                </Contents>
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
    }
};

const connectedTopTrainer = connect(mapStateToProps)(TopTrainer);
export { connectedTopTrainer as TopTrainer };

const Body = styled.div`
`;

const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: ${props => (props.Height)};
    padding-top: 20px;
`;
const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const ControlsChild = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Input = styled.div`
    width: 320px;
    text-align: center;
    margin: 0 10px;
    input {
        width: 100%;
        padding: 4px 10px;
        border: 1px solid #888;
    }
`;
const IconOnlyButton = styled.div`
    color: #888;
    margin-left: ${props => props.Margin};
    i {
        font-size: 18px;
    }
    cursor: pointer;
`;

const Results = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 10px;
    width: calc(100% - 20px);
`;
const TableContrl = styled.div`
    cursor: pointer;
    padding: 0 2px;
    color: ${props => props.Color};
`;

const NoticeWrap = styled.div`
    width: 200px;
    height: 100%;
    border-left: 2px solid #dedede;
    padding: 0 0 0 20px;
    color: #888888;
`;
const Notice = styled.div`
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    border: 1px solid #dedede;
    padding: 5px;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;

    overflow: auto auto;

    ::-webkit-scrollbar{
    　　width: 10px;
    }
    ::-webkit-scrollbar-track{
    　　background: #fff;
    }
    ::-webkit-scrollbar-thumb{
    　　background: #ccc;
    　　border-radius: 10px;
    　　box-shadow: inset 0 0 0 2px #fff;
    }
`;

const NotReply = styled.div`
    margin: 2px 0;
`;